import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { environment } from "../../environments/environment";
import { ECollection } from "../enums/ECollection";
import { IAPIResponse } from "../enums/types";
import { EModelApiPaths } from "../enums/EModelApiPaths";


@Injectable({
  providedIn: 'root'
})
export class ProductsService extends BaseService {

  constructor(public override http: HttpClient,
                  public override utilsService: UtilsService,
                  public override userService: UserService) {
          super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.MP_PRODUCTS}`);
      }

    async sendContactMail(body: any) {
        const encryptedData = this.encryptedPayload(body);
        const options: any = this.userService.getRequestOptions();
        const resp = <any>await this.http.post<IAPIResponse<any>>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.CONTACT_MAIL_SEND, encryptedData, options).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }
}
